"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var DropdownItem = _styledComponents["default"].a.attrs(function () {
  return {
    className: "dropdown-item",
    id: "best-dropdown-item"
  };
}).withConfig({
  displayName: "DropdownItem",
  componentId: "ztf62n-0"
})(["&&&{background-color:#ffffff;color:", ";&:hover{cursor:pointer;color:", ";}}"], function (props) {
  return props.theme["primary"];
}, function (props) {
  return props.theme["mlb-blue"];
});

var _default = DropdownItem;
exports["default"] = _default;